import { render } from "./ClientCallQuizAnsweTabl.vue?vue&type=template&id=82b1a63e"
import script from "./ClientCallQuizAnsweTabl.vue?vue&type=script&lang=js"
export * from "./ClientCallQuizAnsweTabl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__